module.exports = __webpack_public_path__ + "static/img/018网络安全法2.060af70.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/018网络安全法2.jpg
// module id = 1hq3
// module chunks = 0